module.exports = __webpack_public_path__ + "static/img/T7398_test.9b0b034b.png";